
var tm,
team = {
	settings: {
		bioEntry: $('.bio .bio-entry'),
		heroAnchor: $('.team-slider a'),
		slideList: $('.slide-list'),
		slickIt: $('.slick-it'),
		windowX: $(window).width()
	},
	init: function() {
		tm = this.settings;
		this.bindUIActions();
		console.log('team loaded!');
	},
	bindUIActions: function() {
    //Behaviors for the bio-sections on both click and swipe:
        //Show corresponding bio when the slide image is clicked:
        tm.heroAnchor.on('click', function(e) {
            e.preventDefault();
            //animate on click:
            $([document.documentElement, document.body]).animate({
                scrollTop: $(this).offset().top
            }, 600);
            //Hide and Show corresponding bio section:
            $('.bio .select-member').hide();
            $('.bio .bio-entry').hide();
            var person = '#person-' + $(this).data('person');
            $('.bio').find(person).fadeIn();
        });
        //Show corresponding bio when the slides are swiped or arrows clicked:
        tm.slickIt.on('afterChange', function(){
            var currentSlide = tm.slickIt.slick('slickCurrentSlide');
            var theSlide = currentSlide + 1;
            $('.bio .select-member').hide();
            $('.bio .bio-entry').hide();
            var person = '#person-' + theSlide;
            $('.bio').find(person).fadeIn();
        });


    // Team Slider Init
        tm.slickIt.slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: false,
            swipe: true,
            responsive: [
                {
                    breakpoint: 1700,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 1250,
                    settings: {
                        slidesToShow: 1,
                    }
                },

            ]
        });
        //Hide the bio sections:
        tm.bioEntry.hide();
        //If the screen is less than 1024, show the current-slide bio section
        if(tm.windowX < 1024) {
            var initialbio = '#person-' + (tm.slickIt.slick('slickCurrentSlide') + 1);
            $('.bio').find(initialbio).fadeIn();

        }


    // HOME PAGE SLIDER

        // INIT
        tm.slideList.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,

            responsive: [
                {
                    breakpoint: 560,
                    settings: {
                        dots: true,
                        arrows: false,
                    }
                },
            ]
        });
        //While the JS is loading, the slide-content is set to display:none. This function will remove the class .not-loaded, so that the slide-content will display
        var homeContent = $('.slide-item');
        homeContent.removeClass('hidden');


    }
};
